import { energyApi } from "utilities/Axios";

export const getAllDataSources = () => {
  return energyApi.get(`DatasourceMeta/GetAllDatasourceMeta`);
};

export const getAllValueSources = () => {
  return energyApi.get(`/TagType/GetValueTypes`);
};

export const getAllTagTypeSources = () => {
  return energyApi.get(`/TagType/GetAllTagTypes`);
};